import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router, Params } from '@angular/router';
import { Orderitems } from '../../classes/orderitems';
import { CartService } from '../../services/cart.service';
import { CommonService } from '../../services/common.service';
import { ProductsService } from '../../services/products.service';
import { Product } from '../../classes/product';
import { Order } from '../../classes/order';
import { Cityinventory } from '../../classes/invcheck';
import { Shipping } from '../../classes/shipping';
import { Billing } from '../../classes/billing';
import { Cartitems2 } from '../../classes/cartitems';
import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'app-orderdetails',
  templateUrl: './orderdetails.component.html',
  styleUrls: ['./orderdetails.component.css']
})
export class OrderdetailsComponent implements OnInit {
  paymode: any;

  ostatus: any;
  country: string;
  state: string;
  city: string;
  action: any;
  msg: string;
  cquantity = 0;
  citems: number;
  flag = 0;
  counter: any;
  cindex: any;
  payable: number;
  quantity: any;
  pid: number;
  tax: number;
  totaldiscount: number;
  discount: number;
  prodprice: number
  prodsku: any;
  prodname: string;
  data2: Cartitems2[];
  ppinventory: any[];
  stockflag: number;
  ordercountflag: number;
  billingaddress: any;
  shippingaddress: any ;
  billid: number;
  shipid: number;
  shipadd: any;
  city_id = 1;
  counterflagforcancell: number;
  oid: any;
  id: any;
  umobile: any;
  uemail: any;
  uname: any;
  did: number;
  totalpayable: any;
  orderno: any;
  orderitem: Orderitems[];
  productimg= [];
  userid: any;
  order: Order[];
  public loading = false;
  constructor(private route: ActivatedRoute, private cartService: CartService,
     private productService: ProductsService, private commonService: CommonService, private router: Router, private snackbar: MatSnackBar) {
      const udata = this.commonService.getUserDataLocally();
      this.userid = udata.uid;
      this.uname = udata.uname;
      this.uemail = udata.uemail;
      this.umobile = udata.umobile;

      this.route.params.subscribe(params => {
       const orderno = params['id'];
        this.orderno = orderno;
        console.log(this.orderno);
        this.newSubscription();
      });
    }

  ngOnInit() {
  }
  newSubscription() {
    this.loading = true;
    this.getOrderItems();
    this.getOrder();
    this.getOrderStatus();
  }
  getOrderStatus() {
    this.cartService.getOrderStatus()
    .subscribe(
      (x) => {
        this.ostatus = x;
      });
  }
  getOrderItems() {
    this.cartService.getOrderDetail(this.orderno)
    .subscribe(
      (orderitem: Orderitems[]) => {
        this.orderitem = orderitem;
        this.counterflagforcancell = this.orderitem.length;
        if (this.orderitem && this.orderitem.length > 0) {
          for (let i = 0 ; i <  this.orderitem.length; i++) {
            this.getProductimage(this.orderitem[i].sku)
          }
        }
      });
  }
  getProductimage(pid) {
    this.productService.getProductimagebySku(pid)
    .subscribe(
      (x) => {
        console.log(x[0].image);
        this.productimg['id' +  x[0].sku] = x[0].image;
       });
    }
    getOrder() {
        this.cartService.getOrderDetails(this.orderno)
        .subscribe(
          (order: Order[]) => {
            this.loading = false;
            this.order = order;
            this.id = this.order[0].id;
            this.shipid = this.order[0].shippingadd_id;
            this.billid = this.order[0].billingadd_id;
            this.paymode = this.order[0].payment_mode;
            console.log(this.paymode, this.order[0].payment_status);
            this.getOrderShippingAddress();
            this.getOrderBillingAddress();
          });
      }
      cancelOrder() {
        this.loading = true;
        this.counterflagforcancell = this.orderitem.length;
        this.getProductInventory();
      }

      getProductInventory() {
        for (let i = 0 ; i < this.orderitem.length; i++) {
          this.commonService.getInventoryDetails(this.orderitem[i].product_id, this.city_id)
          .subscribe(
            (x) => {
              const id = x[0].id;
              let astock = x[0].actualstock;
              const qty = this.orderitem[i].quantity;
              astock = astock + qty;
              const tstock = astock + x[0].virtualstock;
              if (tstock > 0) {
                this.updateInventoryWithStatus(id, astock, tstock)
              } else {
                this.updateInventoryWithoutStatus(id, astock, tstock)
              }
            });
          }
      }
      updateInventoryWithStatus(id, astock, tstock) {
        const status = 1;
        this.commonService.updateStockWithStatus(id, astock , tstock, status )
        .subscribe(
          (x) => {
            this.counterflagforcancell = this.counterflagforcancell - 1;
            if (this.counterflagforcancell === 0) {
              this.orderCancell();
            }
          });
      }
      updateInventoryWithoutStatus(id, astock, tstock) {
        this.commonService.updateStockWithoutStatus(id, astock , tstock)
        .subscribe(
          (x) => {
            this.counterflagforcancell = this.counterflagforcancell - 1;
            if (this.counterflagforcancell === 0) {
              this.orderCancell();
            }
          });
      }
      orderCancell() {
        this.cartService.updateOrderStatus(this.id)
        .subscribe(
          (x: Order) => {
           this.changeStatusinView();
           });
      }
      changeStatusinView() {
       this.order[0].status_id = 7;
       this.loading = false;
       this.msg = 'order cancelled Successfully';
       this.openSnackBar();
      }
      getOrderShippingAddress() {
        this.cartService.getOrderShippingAddress(this.shipid)
        .subscribe(
          (x) => {
            this.shippingaddress = x;
            this.setName();
          });
      }
      setName(){
        if (this.shippingaddress.city_id == 1){
          this.city = 'Banglore';
          this.state = 'Karnataka';
          this.country = 'India';
        }
      }
      getOrderBillingAddress() {
        this.cartService.getOrderBillingAddress(this.billid)
        .subscribe(
          (x) => {
            this.billingaddress = x
          });
      }
    goForReorder(orderno) {
      this.loading = true;
      this.cquantity = 0;
      this.ordercountflag = this.orderitem.length;
      this.getusercartitems();
    }
    addToCartFromOrderItems() {
      this.stockflag = 0;
      for (let i = 0; i < this.orderitem.length; i++) {
        this.productService.getOrderitems(this.orderitem[i].sku, this.orderitem[i].product_name)
        .subscribe((x) => {
          this.addcart(this.orderitem[i].product_name, this.orderitem[i].sku,
            x[i].price, this.orderitem[i].product_id, this.orderitem[i].quantity, x[i].splprice);
        });
      }
    }
  
    getusercartitems() {
      this.cartService.getUserCartItems(this.userid)
      .subscribe(
        (x: Cartitems2[]) => {
          this.data2 = x;
          this.addToCartFromOrderItems();
          }
        );
    }
    addcart(name: string, sku: string, price: number, id: number, qty, splprice) {
      this.pid = id;
      this.prodname = name;
      this.prodsku = sku;
      this.prodprice = price;
     // this.discount = 0;
     // this.totaldiscount = 0;
     if (splprice === 0) {
      this.discount = 0;
      this.totaldiscount = 0;
      this.payable = price;
    }else {
      this.discount =  price - splprice;
      this.totaldiscount = splprice;
      this.payable = splprice;
    }
      this.checkItems(this.prodsku);
      this.tax = 0 ;
      if (this.flag === 0) {
        this.quantity = qty;
        this.cquantity = this.cquantity + qty;
      //  this.payable = price * this.quantity;
        this.payable = this.payable * this.quantity;
        this.cartService.createCart(this.pid, this.prodname, this.prodsku, this.prodprice,
          this.discount, this.totaldiscount, this.quantity, this.payable, this.tax, this.userid, this.uname)
        .subscribe(
          (x: Cartitems2[]) => {
            this.ordercountflag = this.ordercountflag - 1;
            this.checkAllFlags();
          });
      } else {
        this.quantity = this.data2[this.cindex].quantity + qty;
        this.cquantity = this.cquantity + qty;
       // this.payable = price * this.quantity;
       this.payable = (this.data2[this.cindex].mrp - this.data2[this.cindex].discount) * this.quantity;
        this.cartService.updateCartIfPresent(this.data2[this.cindex].id, this.quantity, this.payable)
        .subscribe(
          (x: Cartitems2[]) => {
            this.ordercountflag = this.ordercountflag - 1;
            this.checkAllFlags();
          });
    }
    }
    checkAllFlags() {
      if (this.ordercountflag === 0) {
        this.loading = false;
        this.test();
      }
    }
    checkItems(sku) {
      this.flag = 0;
          if (this.data2.length > 0) {
            for (let i = 0; i < this.data2.length; i++) {
              if (this.data2[i].sku === sku) {
                this.flag = 1;
                this.cindex = i;
              }
            }
          } else {
            this.flag = 0;
          }
      }
    test() {
      this.cartService.totalcartitems.subscribe(totalcartitems => {
        this.citems = totalcartitems;
      });
     this.msg = 'Items Added To Cart';
      this.openSnackBar();
      this.cartitemchange();
     }
     openSnackBar() {
      this.snackbar.open(this.msg , this.action,{
        duration: 4000,
      });
    }
     cartitemchange() {
      this.citems = this.citems + this.cquantity;
      this.cartService.changeTotalCartItems(this.citems);
     this.goToCart();
    }
    goToCart() {
      this.router.navigate(['/store/cart'])
    }

    updateShipMode(oid) {
      this.loading = true;
      var cod = 'Cash on Delivery';
      this.productService.updatePayStatus(oid, cod)
      .subscribe((x)=>{
        this.loading = false;
        this.msg = 'Payment mode updated to COD';
        this.openSnackBar();
        this.getOrder();
        this.paymode = x.payment_mode;
      });
    }

}
